// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback, useState, useEffect } from "react";
import { useDebounce } from "use-debounce";

import { InlineFormGroup, Label } from "src/styles/form";
import { TextArea } from "src/styles/input";

type Props = {
  description: string,
  handleChange: Function,
};

const Details = ({ description, handleChange }: Props) => {
  const [text, setText] = useState(description || "");
  const [value] = useDebounce(text, 500);

  const handleText = useCallback(
    (e) => {
      setText(e.target.value);
    },
    [setText],
  );

  // Updating redux state when local state is changed after time interval
  useEffect(() => {
    handleChange("description", value);
  }, [value]);

  return (
    <InlineFormGroup>
      <Label htmlFor="checkbox">{i18n.t(k.DETAILS_OBJECTIVE)}</Label>
      <TextArea
        value={text}
        id="description"
        onChange={handleText}
        placeholder="Enter Details / Objective Here"
      />
    </InlineFormGroup>
  );
};

export default Details;
